import { useQuery } from '@apollo/client';
import { transformErrors } from '@core/adapters/errors';
import type { StandardLabel } from '@system-config/label-management/domain';
import { GET_STANDARD_LABELS } from '@system-config/label-management/graphql';
import { useMemo } from 'react';

interface StandardLabelsResponse {
  standardLabels: {
    labels: StandardLabel[];
  };
}

export function useStandardLabels() {
  const { data, loading, error, refetch } = useQuery<StandardLabelsResponse>(GET_STANDARD_LABELS, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  const labels: StandardLabel[] = useMemo(() => data?.standardLabels?.labels || [], [data]);

  const errors = useMemo(() => {
    if (!error) return undefined;

    return transformErrors(error);
  }, [error]);

  return {
    labels,
    loading,
    errors,
    refetch,
  };
}
